import { Component } from '@angular/core';

@Component({
  selector: 'app-scarica-app',
  imports: [],
  templateUrl: './scarica-app.component.html',
  styleUrl: './scarica-app.component.scss'
})
export class ScaricaAppComponent {

}
